module.exports = __webpack_public_path__ + "static/media/galerija_2013 (26).9265c73b.jpg";